import * as z from "zod";

export const notificationTriggerDelaySchema = z
  .number({ required_error: "Delay is required", invalid_type_error: "Enter a delay in whole days" })
  .int("Delay must be a whole number of days")
  .min(0, "Delay must be between 0 and 365 days")
  .max(365, "Delay must be between 0 and 365 days");

export function getFormErrorMessages(errors: unknown): string[] {
  const messages = new Set<string>();
  const visited = new WeakSet<object>();
  const pending: unknown[] = [errors];

  while (pending.length) {
    const value = pending.pop();
    if (!value || typeof value !== "object" || visited.has(value)) continue;
    visited.add(value);

    const prototype = Object.getPrototypeOf(value);
    if (!Array.isArray(value) && prototype !== Object.prototype && prototype !== null) continue;

    if ("message" in value && typeof value.message === "string") messages.add(value.message);

    // Keep depth-first message order without following DOM/React input references.
    const children = Object.entries(value).filter(([key]) => key !== "ref");
    for (let index = children.length - 1; index >= 0; index--) {
      pending.push(children[index][1]);
    }
  }

  return Array.from(messages);
}
